<template>
  <div class="mt55">
    <div
      class="w1200"
      v-show="isShow"
    >
      <HT
        text="ldgh"
        style="margin-top:20px;"
        class="fl"
      />
      <div class="head clearfix">
        <div class="fr bread clearfix">
          <div
            class="fl"
            style="margin-right:15px;color: #064186"
          >
            当前位置:
          </div>
          <div class="fl">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">
                首页
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/gygd/gdyy' }">
                关于固德
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/gygd/ldgh' }">
                领导关怀
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
      </div>
      <div class="content clearfix pr">
        <div
          v-for="(item,index) in list"
          :key="index"
          class="pr clearfix"
        >
          <div
            v-for="(itemC,index) in item.img_list"
            :key="index"
            class="imgWrap fl"
          >
            <div class="imgBox">
              <img :src="require(`@/assets/images/ldgh/${itemC.src}.jpg`)">
            </div>
          </div>
          <div
            class="fl"
            style="width:100%;text-align:center;margin:20px 0;font-size:16px;letter-spacing:3px;"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HT from '@/components/h2.vue'
import { request } from '@/assets/utils/request'

export default {
    data() {
        return {
            list: [],
            isShow: true,
        }
    },
    components: {
        HT
    },
    methods: {
        getList() {
            var that = this;
            request('/mocks/ldgh.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.list = data
                    } catch (e) {
                        that.list = [];
                    }
                }
            })
        }
    },
    mounted() {
        this.getList()
    }
}
</script>

<style scoped>
    .w1200{
        margin: 0 auto;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .content{
        padding: 1px 30px 20px 30px;
        margin: 35px 0 0px 30px;
    }
    .content .title{
        font-size: 18px;
        margin: 50px 0 30px 0;
        color: #033f85;
        position: relative;
    }
    .content .title::before{
        display: block;
        width: 32px;
        height: 32px;
        content: "";
        position: absolute;
        left: -50px;
        top: -5px;
        background: #76bd25;
        border-radius: 32px;
    }
    .content .text{
        margin-bottom: 30px;
    }
    .content .right.text{
        width: 800px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 55px;
        text-indent: 2em;
        font-size: 16px;
        line-height: 26px;
    }
    .imgWrap{
        margin-right: 60px;
        border: 5px solid #5bb62d;
        border-radius: 3px;
    }
    .imgBox{
        width: 300px;
        height: 200px;
    }
    .imgWrap :last-child{
        margin-right: 0;
    }
    .imgBox img{
        width: 100%;
        height: 100%;
    }
</style>

<style>
    .bread .el-breadcrumb__inner.is-link{
        color: #064186;
        font-weight: 500;
    }
    .bread .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link{
        color: #5bb62d;
    }
</style>